
function HeaderOne() {
  return (
    <h1 className='HeadOne'>Bus Where?!</h1>
  );
}

export default HeaderOne;